import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'

import Annotation from '../components/annotation'

import { Flex, Text } from '../components/system'
import { Intro, PageHeading } from '../components/typography'
import { Container } from '../components/containers'

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <Container>
      <Flex height="40vh" alignItems="flex-end">
        <PageHeading fontSize={{ md: 10 }} maxWidth="34rem" lineHeight="solid">
          <Text as="span" fontWeight={0}>
            The purpose of everything we do is to
          </Text>{' '}
          <Annotation color="orange.400">guide</Annotation> the people we serve
        </PageHeading>
      </Flex>
      <Intro>
        In a world where every challenge is complex and unique, good design
        values unity over uniformity. Design is simply the{' '}
        <Annotation type="line" color="orange.400">
          means
        </Annotation>
        . Business outcomes are the{' '}
        <Annotation type="line" color="purple.300">
          goal
        </Annotation>
        .{' '}
        <span role="img" aria-label="party time wayne's world excellent">
          🥳
        </span>{' '}
        <span role="img" aria-label="under construction">
          🚧
        </span>
      </Intro>
    </Container>
  </Layout>
)

export default IndexPage
